export default "__VITE_PUBLIC_ASSET__07440b79__"